import { ECategoryOfWarehouse } from '@models/address.model';
import * as moment from 'moment';
import { Moment } from 'moment';

export function statusIn(statuses: string[], statusCode: string): boolean {
  return statuses.some(status => statusCode === status);
}

export function categoryOfWarehouseIn(categories: string[], categoryOfWarehouse: ECategoryOfWarehouse): boolean {
  return categories.some(category => categoryOfWarehouse === category);
}

// Map date format to 'DD.MM.YYYY'
export function updateDateFormat(date: string | Moment): string {
  return moment(date).format('DD.MM.YYYY');
}

export function dateIsValid(date: string): boolean {
  const apiBadDate = '0001-01-01 00:00:00';

  return date && moment(date).isValid() && date !== apiBadDate;
}
